/* __next_internal_client_entry_do_not_use__ useModalState auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useState, useCallback } from "react";
export var useModalState = function() {
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var openModal = useCallback(function() {
        return setIsOpen(true);
    }, []);
    var closeModal = useCallback(function() {
        return setIsOpen(false);
    }, []);
    return {
        isOpen: isOpen,
        openModal: openModal,
        closeModal: closeModal
    };
};
